import { useSession } from "@/lib/auth-client";
import { trpc } from "@/lib/trpc";
import type { User } from "@/lib/user";

/**
 * Combines Better Auth session gating with the `user.me` tRPC query.
 * Use in layout components instead of duplicating the pattern.
 *
 * Server state lives in React Query — no Zustand intermediary.
 */
export function useAuthenticatedUser() {
  const { data: sessionData, isPending: sessionPending } = useSession();
  const hasSession = !!sessionData?.session;

  const { data: user, isPending: userPending } = trpc.user.me.useQuery(undefined, {
    enabled: hasSession,
    staleTime: 5 * 60 * 1000,
  });

  return {
    user: (user ?? null) as User | null,
    isPending: sessionPending || (hasSession && userPending),
  };
}
